var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.59998 2.39961C1.59998 2.18744 1.68426 1.98395 1.83429 1.83392C1.98432 1.68389 2.1878 1.59961 2.39998 1.59961H4.12238C4.31174 1.5997 4.49493 1.66695 4.63937 1.78942C4.78381 1.91188 4.88012 2.08161 4.91118 2.26841L5.50318 5.81641C5.53146 5.98538 5.50476 6.15898 5.42699 6.31163C5.34922 6.46429 5.22449 6.58795 5.07118 6.66441L3.83278 7.28281C4.27686 8.38333 4.93824 9.38304 5.7774 10.2222C6.61655 11.0613 7.61625 11.7227 8.71677 12.1668L9.33597 10.9284C9.41239 10.7752 9.53592 10.6506 9.68842 10.5729C9.84091 10.4951 10.0143 10.4683 10.1832 10.4964L13.7312 11.0884C13.918 11.1195 14.0877 11.2158 14.2102 11.3602C14.3326 11.5046 14.3999 11.6878 14.4 11.8772V13.5996C14.4 13.8118 14.3157 14.0153 14.1657 14.1653C14.0156 14.3153 13.8121 14.3996 13.6 14.3996H12C6.25598 14.3996 1.59998 9.74361 1.59998 3.99961V2.39961Z",
    fill: "#9CA2AD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/icon-phone.2b24c83d.svg";
export { ForwardRef as ReactComponent };